import type { Recipe } from '@hewey/shared'

// Total hands-on + cook minutes from the scraped source. `null` when the page
// published neither time — those recipes are excluded from the time-based
// collections and filters, and show no time on their card.
export const totalMins = (r: Recipe): number | null => {
	const { prepTimeMins, cookTimeMins } = r
	if (prepTimeMins === null && cookTimeMins === null) return null
	return (prepTimeMins ?? 0) + (cookTimeMins ?? 0)
}

export const formatTotalTime = (mins: number): string => `${mins} min`
